import React, { Component } from "react";
import "./Plantypes.css";
import { Offcanvas, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Plantypes extends Component {
  constructor(props) {
    super(props);
    this.inputFileRef = React.createRef();
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      plantypes: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      cData: {
        ptName: "",
      },
      ptId: "",
      show: false,
      filteredData: null,
      tableClms: [
        {
          name: "S.No",
          selector: (row, i) => row.ptId,
          sortable: true,
          cell: (row) => <span>{row.ptId}</span>,
        },
        {
          name: "Name",
          selector: (row, i) => row.ptName,
          sortable: true,
          cell: (row) => <span>{row.ptName}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row, index) => (
            <div>
              {/* edit button and delete button */}
              <button
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen btn btn-primary m-1"
              ></button>
              <button
                style={{
                  backgroundColor: "#169F85",
                  border: " 1px solid #169F85",
                  color: "#000",
                }}
                // variant="primary"
                onClick={() => this.apisfetchHandlerupdatestatus()}
                className="bi bi-check-square-fill btn btn btn-success status_ageband m-1"
              />{" "}
              <button
                variant="danger"
                onClick={() => this.handleDelete(row, index)}
                className="bi bi-trash btn btn-danger m-1"
              />
              {/* <Button
                variant="secondary"
                onClick={() => this.apisfetchHandlerupdatestatus()}
                className="bi bi-check-square btn btn-secondary"
              ></Button> */}
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false, // Flag to indicate edit mode
      isNewEntry: false,
    };
  }
  //editing data
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      ptId: row.ptId,
      cData: {
        ptName: row.ptName,
      },

      isEditing: true,
    });
  };

  handleEnterNewEntryMode = () => {
    this.setState({ isNewEntry: true });
  };

  // Function to save edited data
  handleEditSave = (row) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    //console.log("Clicked Edit Button. Row Data:", row);
    this.setState({ cData: { ...row }, isEditing: true }, () => {
      //console.log("Edit Data in State:", this.state.insuranceData);
    });
  };
  handleNewEntrySave = () => {
    // const newEntryData = this.state.insuranceData;
    this.setState({
      cData: {
        ptName: "",
      },
      isNewEntry: false,
    });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  // offcanvas Open
  handleShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleClose = () => {
    this.setState({ show: false });
  };
  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.plantypes.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  inputChange = (e, id) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const newFormData = this.state.cData;
    newFormData[fieldName] = fieldValue;
    this.setState({ cData: newFormData });
  };

  validateForm(e) {
    let plantypes = this.state.cData;
    let errors = {};
    let formIsValid = true;

    if (!plantypes["ptName"]) {
      toast.info("Please pass Name");
      formIsValid = false;
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  handleAddClick = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("abStatus", this.state.cData.abStatus);
      formData.append("ptName", this.state.cData.ptName);
      fetch(configData.api_url + "plantypes/all/", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.apisfetchHandler();
            // //console.log(data.status);
            this.setState({
              show: false,
              cData: { ptName: "" },
            });
          }
        });
    }
    //console.log(this.state.cData);
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ptId", row.ptId);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "plantypes/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.apisfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
    //console.log(row.abId);
  };
  apisfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "plantypes/", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" || data.status === "true") {
          this.setState({ plantypes: data.list });
        }
      });
  };
  apisHandlerupdate = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ptId", this.state.ptId);
    formData.append("ptName", this.state.cData.ptName);
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "plantypes/update/", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" || data.status === "true") {
          this.apisfetchHandler();
          this.handleClose();
          this.setState({
            ptId: "",
            cData: {
              ptName: "",
            },
          });
          // this.setState({ insurance: data.list });
        }
        //console.log(this.state.plantypes);
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  apisfetchHandlerupdatestatus = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ptId", this.state.ptId);
    formData.append("ptName", this.state.cData.ptName);
    fetch(configData.api_url + "plantypes/updatestatus/", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" || data.status === "true") {
          this.apisfetchHandler();
          this.handleClose();
          this.setState({
            ptId: "",
            cData: {
              ptName: "",
            },
          });
          // this.setState({ insurance: data.list });
        }
        //console.log(this.state.plantypes);
      });
  };
  componentDidMount() {
    this.apisfetchHandler();
    this.apisfetchHandlerupdatestatus();
  }
  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.plantypes.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );
    return (
      <div className="row">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="" style={{ float: "left" }}>
          <h2>Plantypes</h2>
        </div>
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_content">
              <div className="dataTables_wrapper form-inline dt-bootstrap no-footer">
                <div className="row">
                  <div className="d-flex justify-content-end">
                    <div className="dataTables_length" id="datatable_length">
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleShow}
                        data-target=".bs-familydefination-modal-lg"
                      >
                        New
                      </Button>
                    </div>
                    <Offcanvas
                      show={this.state.show}
                      onHide={this.handleClose}
                      {...this.props}
                      style={{ width: "500px" }}
                      placement="end"
                      backdrop="true"
                    >
                      <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Add Plantypes</Offcanvas.Title>
                      </Offcanvas.Header>
                      <Offcanvas.Body>
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <form className="form-horizontal form-label-left input_mask">
                              <div className="col-md-12 col-sm-12 col-xs-12 form-group ">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="ptName"
                                  name="ptName"
                                  value={this.state.cData.ptName}
                                  placeholder="Name"
                                  onChange={this.inputChange}
                                />
                              </div>
                            </form>
                            <br />
                            <div className="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-end">
                              <button
                                className=" btn btn-warning me-2"
                                style={{
                                  backgroundColor: "#fff",
                                  color: "#000",
                                  borderColor: "#ccc",
                                }}
                                onClick={this.handleClose}
                              >
                                Close
                              </button>{" "}
                              <button
                                className="btn btn-primary me-2"
                                style={{
                                  backgroundColor: "#23547e",
                                  color: "#fff",
                                  borderColor: "#2e6da4",
                                }}
                                onClick={this.handleAddClick}
                              >
                                save{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Offcanvas.Body>
                    </Offcanvas>
                  </div>
                </div>
                <div>
                  {" "}
                  {this.state.isEditing && (
                    // Edit Offcanvas
                    <Offcanvas
                      show={this.state.isEditing}
                      onHide={() => this.setState({ isEditing: false })}
                      {...this.props}
                      style={{ width: "500px", height: "auto" }}
                      placement="end"
                      backdrop="true"
                    >
                      <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Edit PlanTypes</Offcanvas.Title>
                      </Offcanvas.Header>
                      <Offcanvas.Body>
                        <div className="form-horizontal form-label-left input_mask">
                          <form className="form-horizontal form-label-left input_mask">
                            <div className="col-md-12 col-sm-12 col-xs-12 form-group ">
                              <input
                                type="text"
                                className="form-control"
                                id="ptName"
                                name="ptName"
                                value={this.state.cData.ptName}
                                placeholder="Name"
                                onChange={this.inputChange}
                              />
                            </div>
                            <br />
                            <div style={{ float: "right" }}>
                              <button
                                className="btn btn-primary me-2"
                                style={{
                                  backgroundColor: "#23547e",
                                  color: "#fff",
                                  borderColor: "#2e6da4",
                                }}
                                onClick={this.apisHandlerupdate}
                              >
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                      </Offcanvas.Body>
                    </Offcanvas>
                  )}
                </div>
                <div>
                  <div>
                    {/* searchbar,pagination,filter */}
                    <input
                      style={{ float: "left", marginBottom: "10px" }}
                      type="text"
                      onChange={this.handleFilter}
                      placeholder="Search..."
                    />
                    <DataTable
                      data={paginatedData}
                      columns={this.state.tableClms}
                      pagination
                      paginationServer
                      paginationTotalRows={
                        this.state.filteredData
                          ? this.state.filteredData.length
                          : this.state.plantypes.length
                      }
                      // paginationTotalRows={this.state.insurance.length}
                      onChangeRowsPerPage={this.handlePerRowsChange}
                      onChangePage={this.handlePageChange}
                      paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                      paginationPerPage={100}
                      keyField="id"
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 60, 70, 80, 90, 100]}
                      className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
